






































import Vue from 'vue';
import firebase from 'firebase/compat/app'
import { Auth } from '@/firebase/auth'

export default Vue.extend({
  name: 'Header',

  data: () => ({
    isLogin: false
  }),

  created: function() {
    this.checkLoginState()
  },

  methods: {
    toHome() {
      this.$router.push({ name: 'Home' })
    },

    checkLoginState () {
      firebase.auth().onAuthStateChanged( (user) => {
        if (user) {
          this.isLogin = true
          // User is signed in, see docs for a list of available properties
          const uid = user.uid;
        } else {
          this.isLogin = false
        }
      })
    },

    logout() {
      firebase.auth().signOut()
      .then(() => {
        alert('ログアウトしました。')
        this.$router.push({ name: 'Home' })
      })
      .catch(() => {
        alert('ログアウトに失敗しました。もう一度ログアウトボタンをタップしてください。')
      })
    },
    
    toLogin() {
      const currentUrl = '/'
      localStorage.setItem('destination', currentUrl)
      this.$router.push({ name: 'Login' })
    }
  }
});
